import {
    ChangeDetectorRef,
    Directive,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnDestroy,
    OnInit,
} from "@angular/core";
import {FUIAbstractInput} from "../../framework/abstract-input";
import {FUIOptionsService, SelectionsEvent} from "../../framework/options.service";
import {Subscription} from "rxjs";
import {FUIEventsService} from "../../../events/events.service";

@Directive()
export abstract class FUIAbstractMoreInput extends FUIAbstractInput implements OnDestroy, OnInit {
    @Input() public field: string;

    private _$click: Subscription;
    private _key: string;
    private _options: Array<any>;
    public filteredOptions: Array<any>;
    private _popped: boolean;

    constructor(public elementRef: ElementRef,
                protected eventsService: FUIEventsService,
                protected optionsService: FUIOptionsService,
                changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
        this.added$ = new EventEmitter<boolean>();
        this.extended$ = new EventEmitter<boolean>();
        this.options = new Array<any>();
        this.filteredOptions = new Array<any>();
    }

    ngOnInit(): void {
        this._$click = this.eventsService.click$.subscribe(
            (click) => {
                if (this.popped) {
                    if (this.elementRef.nativeElement.contains(click.target)) {

                    }
                    else {
                        this.popped = false;
                    }
                }
            }
        )
    }

    override ngOnDestroy(): void {
        super.ngOnDestroy();
        this._$click.unsubscribe();
    }

    /**
     *
     * @returns {string}
     */
    get key(): string {
        return this._key;
    }

    /**
     *
     * @param {string} key
     */
    @Input()
    set key(key: string) {
        if (this._key !== key) {
            this._key = key;
        }
    }

    /**
     *
     * @returns {Array<any>}
     */
    get options(): Array<any> {
        return this._options;
    }

    /**
     *
     * @param {Array<any>} options
     */
    @Input()
    set options(options: Array<any>) {
        if (options) {
            if (options.length != undefined) {
                this._options = options;
                this.filteredOptions = this._options;
            }
        }
    }

    /**
     *
     * @returns {boolean}
     */
    get popped(): boolean {
        return this._popped;
    }

    /**
     *
     * @param {boolean} popped
     */
    set popped(popped: boolean) {
        this._popped = popped;
        this.focussed = popped;
        this.focussed$.emit(this.focussed);
    }

    /**
     *
     * @returns {string}
     */
    override get value(): any {
        return this._value;
    }

    /**
     * Add button handler
     */
    public add(): void {
        this.added$.emit(true);
    }

    /**
     * Click action for a select is different to other controls, it
     * only wants to pop up it's dropdown, not focus on the underlying input
     */
    public override click(): void {
        this.popped = !this.popped;
    }

    /**
     * If a user presses enter or space while focussed on the element,
     * use the click method to apply the relevant interaction
     * @param {KeyboardEvent} keyboardEvent
     */
    @HostListener("keypress", ["$event"])
    public keypress(keyboardEvent: KeyboardEvent) {
        if (!this.disabled) {
            if (keyboardEvent.code === "Enter" || keyboardEvent.code === "Space" || keyboardEvent.key === "Enter" || keyboardEvent.key === " ") {
                this.click();
            }
        }
    }

    /**
     * Check if the list of options is empty
     * @returns {boolean}
     */
    public empty(options: Array<any>): boolean {
        if (this.loading) {
            return false;
        }
        else {
            if (options) {
                if (options.length > 0) {
                    return false;
                }
                else {
                    return true;
                }
            }
            else {
                return true;
            }
        }
    }

    /**
     * Emit an event when the extended search button
     * is clicked
     */
    public extend(): void {
        this.extended$.emit(true);
    }

    /**
     * Check if the list of options is empty
     * @returns {boolean}
     */
    public filled(options: Array<any>): boolean {
        if (options) {
            if (options.length > 0) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }

    /**
     *
     * @param {boolean} popped
     */
    public pop(popped: boolean): void {
        this.popped = popped;
    }

    /**
     * Set the value to the selections passed out from the
     * multiselect options
     * @param event
     */
    select(event: SelectionsEvent): void {
        if (event.selections) {
            super.value = event.selections;
        }
    }

    /**
     *
     * @param value
     */
    public override writeValue(value: any): void {
        this._value = value;

        if (this._value) {
            this.valued = true;
            this.optionsService.selections = this._value;
            this.changeDetectorRef.detectChanges();
        } else if (this.valued) {
            this.valued = false;
            this.optionsService.selections = [];
            this.changeDetectorRef.detectChanges();
        }
    }
}
